import React from "react";
export const TOUR_STEPS = [
  {
    title: "Selector",
    target:
      "#root > div > nav.navbar.navbar-expand-md.fixed-top-sm.flex-nowrap.justify-content-between.bg-dark.navbar-dark > button.btn.px-2.nav-item.active.align-items-center.align-self-center.central-button",
    content: (
      <div>
        This is where you can choose different Fantasy Games or different
        leagues <br />{" "}
        <p className="text-danger">
          Click The Highlighted Section Above to Continue / Click Next to Skip
          this
        </p>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "League Selection",
    target: "#customized-dialog-title > h6 > div > nav > ol > li:nth-child(3)",
    content: <div>This is where you can click and change the league</div>,
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Schedule",
    target: "#ul-horizontal-scroll > li:nth-child(1)",
    content: (
      <div>
        This shows list of dates for which the contests on Dream11 are announced
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: false,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Game List",
    target: ".slate-card-1",
    content: (
      <div>
        This shows list of all the announced games (on Dream11) for the chosen
        date
        <br />{" "}
        <p className="text-danger">
          Click The Highlighted Card Below to Continue
        </p>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },

  {
    title: "Player Count",
    target:
      "#root > div > header > div > nav > div.d-flex.justify-content-between > div > a.nav-link.disabled.text-white.text-nowrap.text-white",
    content: (
      <div>
        This shows the total players count
        <br />
        This will change to 22 once the squad is announced
      </div>
    ),
    disableBeacon: false,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideBackButton: true,
    hideFooter: false,
    placement: "bottom",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
  },
  {
    title: "Time left",
    target:
      "#root > div > header > div > nav > div.d-flex.justify-content-between > div > a.nav-link.font-weight-bolder.text-nowrap.text-danger",
    content: (
      <div>
        This shows the time remaining before the contests on Dream11 gets locked
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "bottom",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Search and Filter",
    target:
      "#root > div > header > div > nav > div.d-flex.w-100.m-1.p-1.bg-dark.border.border-secondary.rounded",
    content: (
      <div>You can search the players to filter and narrow the results</div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "bottom",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Player Information",
    target: "#root > div > div.playerCard__main > div > div:nth-child(2)",
    content: (
      <div>
        This shows the Player Information and various other stats that you can
        utilize while making your Dream Team
        <br />
        <p>
          Also, If you click on any player, You will be redirected to his{" "}
          <b>In-Depth Analysis</b>
        </p>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Fantasy Point Prediction",
    target:
      "#root > div > div.playerCard__main > div > div:nth-child(2) > div.d-flex.bg-black > div.d-flex.align-items-center.flex-column.mr-2",
    content: (
      <div>
        This shows Spontasy's Fantasy Points Prediction for the selected
        player
        <br />
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Player Lineup Exposure",
    target:
      "#root > div > div.playerCard__main > div > div:nth-child(2) > div.d-flex.bg-black > div.btn-group.dropleft.mr-2",
    // target: "#root > div > div.playerCard__main > div > div:nth-child(2)"
    content: (
      <div>
        This submenu helps in setting up the exposure for lineup generation
        <br />
        <div className="list-group m-2 p-2">
          <dl className="row">
            <dt className="col-sm-3 text-muted">Lock</dt>

            <dd className="col-sm-9 text-muted align-items-center align-self-center">
              This means the player will <b>ALWAYS</b> appear in your lineups
            </dd>
            <dt className="col-sm-3 text-muted">Exclude</dt>
            <dd className="col-sm-9 text-muted">
              This means the player will <b>NEVER</b> appear in your lineups
            </dd>
            <dt className="col-sm-3 text-muted">Reset</dt>
            <dd className="col-sm-9 text-muted">
              Reset Exposure Setting for the player
            </dd>
          </dl>
        </div>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },

  {
    title: "Player Position",
    target: "#navbar2 > ul > li:nth-child(1)",
    content: (
      <div>
        This Submenu will help you filter the players based on the Player
        Position
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Stats",
    target: "#navbar2 > ul > li:nth-child(2)",
    content: (
      <div>
        This Submenu will help you sort the Players based on a specific stat
        <br />
        Click on the same stat <b>again</b> to reverse the sorting order
        <br />
        You can also toggle the eye icon to hide/show a perticular stat
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideBackButton: true,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },

  {
    title: "Filters",
    target: "#navbar2 > ul > li:nth-child(3)",
    content: (
      <div>
        This Submenu will help you filter the players based on their Teams &
        Playing Status
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Player Type",
    target: "#navbar2 > ul > li:nth-child(4)",
    content: (
      <div>
        This Submenu will help you visualize the <b>PFP</b> stat that is
        Spontasy's Prediction for the Player
        <br />
        Different Options will change the Projection Numbers according to
        Dream11 notions
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Settings",
    target:
      "#root > div > nav.navbar.navbar-expand-md.fixed-top-sm.flex-nowrap.justify-content-between.bg-dark.navbar-dark > a:nth-child(2) > svg.MuiSvgIcon-root.align-items-center.align-self-center.text-primary",
    content: (
      <div>
        This is where you will find FAQs/Information regarding the statistics
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    //     spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Lineups",
    target:
      "#root > div > nav.navbar.navbar-expand-md.fixed-top-sm.flex-nowrap.justify-content-between.bg-dark.navbar-dark > div > svg",
    content: (
      <div>
        This is the option from where you can go to <b>Lineup Generation</b>
        <br />
        <p className="text-danger">
          Click the Lineups icon to continue the tour
        </p>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Lineup Options",
    target: "#staticBackdropLineUp > div > div > div:nth-child(2) > ul > li",
    content: (
      <div>
        This Dialog Contains Options related to Lineup Generation
        <br />
        Currently we have <br/>
        <ul>
          <li>
            Automatic Lineup Generation
          </li>
          <li>
            Recommended Lineups
          </li>
          <li>
            My Lineups
          </li>
        </ul> 
        <small>
          <i>More Options Coming Soon</i>
        </small>
        <br />
        <p className="text-danger">Click Generate Lineups to continue</p>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    hideBackButton: true,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Lineup Count",
    target:
      "body > div.MuiDialog-root > div.MuiDialog-container.MuiDialog-scrollPaper > div > ul > li:nth-child(1)",
    content: (
      <div>
        With the help of the slider you can choose how many lineups you want to
        create
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Optimizer Selection",
    target:
      "body > div.MuiDialog-root > div.MuiDialog-container.MuiDialog-scrollPaper > div > ul > li:nth-child(3)",
    content: (
      <div>
        Choose one of the statistics from the menu as the optimizer
        <br />
        The system will give you best lineups based on it
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },
  {
    title: "Generate",
    target:
      "body > div.MuiDialog-root > div.MuiDialog-container.MuiDialog-scrollPaper > div > header > div > button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn.text-white",
    content: (
      <div>
        Clicking this button will generate lineups based on your configuration.
        <br />
        <p className="text-danger">Click Generate to see the Lineups.</p>
      </div>
    ),
    // disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: false,
    hideFooter: false,
    placement: "top",
    spotlightClicks: true,
    styles: {
      options: {
        zIndex: 10000,
      },
    },
    disableBeacon: false,
  },

  // {
  //   title: "Lineup Card",
  //   target:
  //     "#root > div.row.row-cols-1.row-cols-md-2.row-cols-lg-3.row-cols-sm-2.row-cols-xl-3 > div:nth-child(1)",
  //   // "#root > div.row.row-cols-1.row-cols-md-2.row-cols-lg-3.row-cols-sm-2.row-cols-xl-3 > div:nth-child(1)",
  //   content: (
  //     <div>
  //       This is the lineup card that adheres to the Dream11 constraints and has
  //       optimal value of your chosen Optimizer
  //     </div>
  //   ),
  //   disableBeacon: false,
  //   disableOverlayClose: true,
  //   hideCloseButton: false,
  //   hideFooter: false,
  //   placement: "auto",
  //   spotlightClicks: false,
  //   styles: {
  //     options: {
  //       zIndex: 10000,
  //     },
  //   },
  // },

  // {
  //   title: "Lineup Options Menu",
  //   target: "#root > nav > svg",
  //   content: <div>Clicking here will open Lineup Options Menu</div>,
  //   // disableBeacon: true,
  //   disableOverlayClose: true,
  //   hideCloseButton: false,
  //   hideFooter: false,
  //   placement: "auto",
  //   spotlightClicks: true,
  //   styles: {
  //     options: {
  //       zIndex: 10000,
  //     },
  //   },
  //   disableBeacon: false,
  // },
];
